'use client';

import { c as _c } from "react/compiler-runtime";
import CircularPercentage from '@/comps/CircularPercentage';
import { InfoTooltip } from '@/comps/info-tooltip';
import { MODEL_SAVINGS_POSITIVE_COLOR } from '@/domains/pages/model-savings/constants';
import { AIFI_DATA_NUMBER_CLASS } from '@/domains/pages/ai-proficiency/typography';
import { cn } from '@/utils/shad';
import type { ReactNode } from 'react';
type ShareOfTotalLabelProps = {
  percent: number;
  label: string;
  /** Explains what the ring measures, shown behind an (i) next to the label. */
  tooltip?: ReactNode;
  className?: string;
};
export function ShareOfTotalLabel(t0) {
  const $ = _c(16);
  const {
    percent,
    label,
    tooltip,
    className
  } = t0;
  const normalized = Math.min(1, Math.max(0, percent / 100));
  let t1;
  if ($[0] !== className) {
    t1 = cn("flex items-center gap-2", className);
    $[0] = className;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = {
      color: MODEL_SAVINGS_POSITIVE_COLOR
    };
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = cn("text-[12px] text-nowrap", AIFI_DATA_NUMBER_CLASS);
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== normalized) {
    t4 = <CircularPercentage percentage={normalized} radius={12} stroke={2} strokeColor={MODEL_SAVINGS_POSITIVE_COLOR} className={t3} />;
    $[4] = normalized;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] !== label || $[7] !== tooltip) {
    t5 = tooltip ? <InfoTooltip content={tooltip} label={`${label} explanation`} /> : null;
    $[6] = label;
    $[7] = tooltip;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  let t6;
  if ($[9] !== label || $[10] !== t5) {
    t6 = <span className="flex items-center text-[12px] leading-tight text-muted-foreground">{label}{t5}</span>;
    $[9] = label;
    $[10] = t5;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  let t7;
  if ($[12] !== t1 || $[13] !== t4 || $[14] !== t6) {
    t7 = <div className={t1} style={t2}>{t4}{t6}</div>;
    $[12] = t1;
    $[13] = t4;
    $[14] = t6;
    $[15] = t7;
  } else {
    t7 = $[15];
  }
  return t7;
}